<button adaptButton="aiCoachAccess"></button>
